import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TrailCondition } from '../dto/trail-condition';

@Injectable({
  providedIn: 'root'
})
export class TrailConditionService {

  private apiUrl = environment.apiRoot + '/trialcondition';

  constructor(private http: HttpClient) { }

  getConditionByTrialId(trialId: number): Observable<TrailCondition> {
    return this.http.get<TrailCondition>(this.apiUrl + '/details?trialId=' + trialId);
  }

  updateTrialCondition(model: TrailCondition): Observable<TrailCondition> {
    return this.http.put<TrailCondition>(this.apiUrl + '/update', model);
  }
}
